import { render, staticRenderFns } from "./teste.vue?vue&type=template&id=4d95aef2&scoped=true&"
import script from "./teste.vue?vue&type=script&lang=js&"
export * from "./teste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d95aef2",
  null
  
)

export default component.exports